const { uaCallWithReturnValue } = require('./ua');

class ZepEvent {
    /**
     * Constructor
     */
    constructor(eventName, version) {
        this.eventName = eventName;
        this.version = version;
        this.options = {};
        this.payload = {};
        this.element = null;
    }

    /**
     * Add the event to the payload
     *
     * @param {Object} [event]
     * @returns {this}
     */
    withPayload(event) {
        this.payload.event = event;

        return this;
    }

    /**
     * Add the options
     *
     * @param {Object} [options]
     * @returns {this}
     */
    withOptions(options) {
        this.options = options;

        return this;
    }

    /**
     * Add page information
     *
     * @param {String} [pageId]
     * @param {String} [pageAlias]
     * @returns {this}
     */
    withPageInfo(pageId, pageAlias) {
        this.payload.context_page_id = pageId;
        this.payload.context_page_alias = pageAlias;

        return this;
    }

    /**
     * Add element that is interacted. Only required if an element is interacted
     *
     * @param {Object} [element]
     *
     * @returns {this}
     */
    withElement(element) {
        this.element = element;

        return this;
    }

    /**
     * Add the categorty ex: interaction, view
     *
     * @param {String} [category]
     * @returns {this}
     */
    withCategory(category) {
        this.payload.context_category = category;

        return this;
    }

    /**
     * to send the event with the provided data
     *
     */
    sendAsync() {
        return uaCallWithReturnValue(
            'zepEvent',
            this.eventName,
            this.version,
            this.payload,
            this.options,
            this.element
        );
    }
}

module.exports = {
    ZepEvent,
};
